<template>
  <div :style="{ marginLeft: $vuetify.breakpoint.mdAndUp ? '120px' : '20px' }">
    <!-- Start Shift Button -->
    <v-btn
      v-if="!shift"
      tile small depressed
      color="primary"
      class="text-none text-body-2"
      @click="shift = 'ongoing'"
    >
      Start Shift
    </v-btn>

    <div v-if="shift == 'ongoing'">
      <!-- End Shift Button -->
      <v-btn
        tile small depressed
        color="error"
        class="text-none text-body-2"
        @click="shift = 'end'"
      >
        End Shift
      </v-btn>
      <!-- End Shift Timer -->
      <span
        class="ml-3 mr-5"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        00:00:01
      </span>

      <!-- Break Start Button -->
      <v-btn
        tile small depressed
        color="primary"
        class="text-none text-body-2"
      >
        Break Start
      </v-btn>
      <!-- Break Start Timer -->
      <span
        class="ml-3 mr-5"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        00:00:00
      </span>
    </div>

    <!-- Shift Ended Button w/ Timer -->
    <v-btn
      v-if="shift == 'end'"
      tile small depressed
      color="primary"
      class="text-none text-body-2"
      @click="shift = null"
    >
      Shift ended:
      <span class="font-weight-bold ml-1">09:03:23</span>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'ShiftSchedule',

    data: () => ({
      shift: null
    }),

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>